module.exports = __webpack_public_path__ + "media/2-z.c0b985a8.wav";